/* @flow */

export const SIMULATE_TOPICS_FETCH = 'SIMULATE_TOPICS_FETCH';
export const SIMULATE_TOPIC_FETCH = 'SIMULATE_TOPIC_FETCH';

export const FETCH_TOPICS_REQUEST = 'FETCH_TOPICS_REQUEST';
export const FETCH_TOPICS_SUCCESS = 'FETCH_TOPICS_SUCCESS';
export const FETCH_TOPICS_FAILURE = 'FETCH_TOPICS_FAILURE';

export const LAZY_FETCH_TOPICS_REQUEST = 'LAZY_FETCH_TOPICS_REQUEST';
export const LAZY_FETCH_TOPICS_SUCCESS = 'LAZY_FETCH_TOPICS_SUCCESS';
export const LAZY_FETCH_TOPICS_FAILURE = 'LAZY_FETCH_TOPICS_FAILURE';

export const FETCH_TOPIC_REQUEST = 'FETCH_TOPIC_REQUEST';
export const FETCH_TOPIC_SUCCESS = 'FETCH_TOPIC_SUCCESS';
export const FETCH_TOPIC_FAILURE = 'FETCH_TOPIC_FAILURE';

export const CREATE_TOPIC_REQUEST = 'CREATE_TOPIC_REQUEST';
export const CREATE_TOPIC_SUCCESS = 'CREATE_TOPIC_SUCCESS';
export const CREATE_TOPIC_FAILURE = 'CREATE_TOPIC_FAILURE';

export const PATCH_TOPIC_REQUEST = 'PATCH_TOPIC_REQUEST';
export const PATCH_TOPIC_SUCCESS = 'PATCH_TOPIC_SUCCESS';
export const PATCH_TOPIC_FAILURE = 'PATCH_TOPIC_FAILURE';

export const DELETE_TOPIC_REQUEST = 'DELETE_TOPIC_REQUEST';
export const DELETE_TOPIC_SUCCESS = 'DELETE_TOPIC_SUCCESS';
export const DELETE_TOPIC_FAILURE = 'DELETE_TOPIC_FAILURE';

export const BOOKMARK_TOPIC_REQUEST = 'BOOKMARK_TOPIC_REQUEST';
export const BOOKMARK_TOPIC_SUCCESS = 'BOOKMARK_TOPIC_SUCCESS';
export const BOOKMARK_TOPIC_FAILURE = 'BOOKMARK_TOPIC_FAILURE';

export const PARTIAL_TOPIC_UPDATE = 'PARTIAL_TOPIC_UPDATE';

export const FETCH_IS_TOPIC_BOOKABLE_REQUEST =
  'FETCH_IS_TOPIC_BOOKABLE_REQUEST';
export const FETCH_IS_TOPIC_BOOKABLE_SUCCESS =
  'FETCH_IS_TOPIC_BOOKABLE_SUCCESS';
export const FETCH_IS_TOPIC_BOOKABLE_FALIURE =
  'FETCH_IS_TOPIC_BOOKABLE_FALIURE';

export const FETCH_TOPIC_MODERATION_REASON_REQUEST =
  'FETCH_TOPIC_MODERATION_REASON_REQUEST';
export const FETCH_TOPIC_MODERATION_REASON_SUCCESS =
  'FETCH_TOPIC_MODERATION_REASON_SUCCESS';
export const FETCH_TOPIC_MODERATION_REASON_FAILURE =
  'FETCH_TOPIC_MODERATION_REASON_FAILURE';

export const PATCH_TOPIC_MODERATION = 'PATCH_TOPIC_MODERATION';
